<div appClickOutside (clickOutside)="!isCollapsed && closeMenu()" class="fixed-top app-office-nav">
  <nav class="navbar navbar-inverse">
    <div class="d-flex align-items-center">
      <button
        class="navbar-toggler btn btn-lg btn-icon-only btn-text-dark"
        id="menuButton"
        type="button"
        (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed"
        aria-controls="navbarMenu">
        <i class="modus-icons notranslate">menu</i>
      </button>
      <app-office-logo></app-office-logo>
    </div>

    <select class="form-control app-office-nav__company-select" [formControl]="companyControl">
      @for (data of companyList$(); track data.HQCo) {
        <option [ngValue]="data.HQCo">{{ data.Name }}</option>
      }
    </select>
  </nav>
  <div class="collapse" #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
    <div class="p-4 app-office-nav__collapse__wrapper">
      <div class="row">
        <div class="col-md-3 col-sm-12 col-xs-12 app-office-nav__side-menu">
          <ul class="nav flex-column nav-pills" id="formList" role="tablist" aria-orientation="vertical">
            @for (groupedForm of groupedFormList$(); track $index) {
              <li class="nav-item">
                <a
                  class="nav-link"
                  [ngClass]="{ active: groupedForm.ModuleShortName === preselectedModule }"
                  data-toggle="pill"
                  role="tab"
                  aria-controls="{{ groupedForm.name }}"
                  aria-selected="false"
                  (click)="groupSelected(groupedForm)"
                  style="cursor: pointer"
                  >{{ groupedForm.name }}</a
                >
              </li>
            }
          </ul>
        </div>
        @let selectedGroup = selectedGroup$();
        @if (selectedGroup && selectedGroup.name !== INQUIRIES_MENU_ITEM.name) {
          <div class="col-md-9 col-sm-12 col-xs-12 app-office-nav__form-select">
            <div class="row">
              @if (selectedGroup.formList.length) {
                <button appButton="primary" class="ml-3" (click)="routeToReportGateway()">View Reports</button>
              }
            </div>
            <div class="row d-block ml-0">
              @for (subGroup of selectedGroup.formList; let i = $index; track i) {
                <ul
                  class="list-group col-md-6 col-sm-12 col-xs-12 d-block mt-3"
                  [ngClass]="{ floatLeftOdd: i % 2 === 0, floatRightEven: i % 2 === 1 }">
                  @if (subGroup[0].FormGroup !== null) {
                    <div>
                      <h6>{{ subGroup[0].FormGroup }}</h6>
                      @for (item of subGroup; track item.FormName) {
                        <li
                          class="list-group-item"
                          [ngClass]="{ active: item.FormName === selectedForm }"
                          (click)="itemSelected(item)"
                          style="cursor: pointer">
                          {{ item.FormDesc }}
                        </li>
                      }
                    </div>
                  }
                </ul>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
